import React, { Fragment, useEffect, useRef, useState } from "react";
import { Grid, MenuItem, Select, Typography } from "@material-ui/core";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
export default function TimeRange({
  dates,
  changeDate,
  timeRange,
  changeTimeRange,
  activeDate,
  ifAnyStaffAvailable,
}) {
  const swiper = useSwiper();
  const swiperRef = useRef<any | null>(null);
  const firstWeek = dates.slice(0, 7);
  const secondWeek = dates.slice(7, dates.length);

  const [selectDate, setSelectDate] = useState<string>(dates[0].dateYear);
  const [buttonPressed, setButtonPressed] = useState<boolean>(false);
  useEffect(() => {
    var slideArr = Array.prototype.slice.call(
        document.querySelector("#staff-slide > .swiper-wrapper")?.children
      ),
      selectArr = document.querySelector(`.dt-${selectDate}`);
    if (!buttonPressed) {
      swiperRef.current.swiper.slideTo(slideArr.indexOf(selectArr), 300);
    }
  }, [selectDate]);
  function handleButtonChange(value) {
    setButtonPressed(true);
    setSelectDate(dates[0].dateYear);
    changeDate(value);
  }
  function handleSelect(e) {
    // swiper.slideTo(index, speed, runCallbacks)
    setButtonPressed(false);
    setSelectDate(e.target.value);
    changeDate(e.target.value);

    // document.querySelector(".dates-select")?.classList.add("select-active");
  }
  return (
    <Fragment>
      <Typography className="page-description">
        ① ご予約希望の日付を選択してください。本日から2週間先まで予約できます。
      </Typography>
      {/* <div className="date-range-wrapper">
        <div className="dates-column">
          {firstWeek.map((date, i) => {
            var hideOnModile = false;
            if (i > 3) {
              hideOnModile = true;
            }
            return (
              <div
                key={i}
                onClick={(e) => changeDate(date.dateYear)}
                className={
                  activeDate == `dt-${date.dateYear}`
                    ? `staff-date dt-${date.dateYear} active ${
                        hideOnModile ? "hide-mobile" : ""
                      }`
                    : `staff-date dt-${date.dateYear} ${
                        hideOnModile ? "hide-mobile" : ""
                      }`
                }
              >
                {date.dayName} <br />
                {date.month}/ <span>{date.day}</span>
              </div>
            );
          })}
        </div>
        <div className="dates-select">
          <Select value={selectDate} onChange={(e) => handleSelect(e)}>
            {dates.map((date, i) => (
              <MenuItem value={date.dateYear} key={i}>
                {date.date}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div> */}
      <div className="date-select-wrapper">
        <div className="swiper-wrap">
          <Swiper
            slidesPerView={4}
            spaceBetween={4}
            modules={[Navigation]}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            ref={swiperRef}
            breakpoints={{
              768: {
                slidesPerView: 7,
                spaceBetween: 5,
              },
            }}
            id="staff-slide"
          >
            {dates.map((date: any, id: number) => (
              <SwiperSlide
                key={id}
                onClick={(e) => handleButtonChange(date.dateYear)}
                className={
                  activeDate == `dt-${date.dateYear}`
                    ? `staff-date dt-${date.dateYear} active`
                    : `staff-date dt-${date.dateYear}`
                }
              >
                <Typography>
                  <span className="day-name">
                    <span>{date.dayName}</span>
                  </span>
                  {date.month}/ <span className="day-date">{date.day}</span>
                </Typography>
              </SwiperSlide>
            ))}
          </Swiper>
          <button className="swiper-button-next"></button>
          <button className="swiper-button-prev"></button>
        </div>
        <div className="dates-select">
          <Select value={selectDate} onChange={(e) => handleSelect(e)}>
            {dates.map((date, i) => (
              <MenuItem value={date.dateYear} key={i}>
                {date.date}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      {ifAnyStaffAvailable && (
        <Fragment>
          <Typography className="page-description">
            ②時間帯を選択してください
          </Typography>
          <Grid container className="staff-time-wrapper">
            <Grid
              item
              md
              sm
              xs
              className={
                timeRange == "9-13" ? "time-range active" : "time-range"
              }
              onClick={(e) => changeTimeRange("9-13")}
            >
              9:00〜13:00
            </Grid>
            <Grid
              item
              md
              sm
              xs
              className={
                timeRange == "13-17" ? "time-range active" : "time-range"
              }
              onClick={(e) => changeTimeRange("13-17")}
            >
              13:00〜17:00
            </Grid>
            <Grid
              item
              md
              sm
              xs
              className={
                timeRange == "17-21" ? "time-range active" : "time-range"
              }
              onClick={(e) => changeTimeRange("17-21")}
            >
              17:00〜21:00
            </Grid>
          </Grid>
        </Fragment>
      )}
    </Fragment>
  );
}
